export default {
    namespaced: true,
    state: {
        lng: 0,
        lat: 0
    },
    actions: {
        update: ({ commit }, position) => {
            commit("LOCATION", position);
        }
    },
    mutations: {
        LOCATION(state, position) {
            state.lng = position.lng;
            state.lat = position.lat;
        }
    }
};
